import logo from '../assets/logo.png'

/**
 * Logo de MixCRM. Usa el PNG oficial (fondo transparente), así se ve igual en
 * tema claro y en oscuro. Es el mismo archivo del que se generan el favicon,
 * los iconos de la PWA y el del APK, para que la marca sea una sola en todos
 * lados.
 */
export default function MixLogo({ size = 40, style, alt = 'MixCRM' }) {
  return (
    <img
      src={logo}
      width={size}
      height={size}
      alt={alt}
      style={{ objectFit: 'contain', display: 'block', ...style }}
    />
  )
}
